module.exports = __webpack_public_path__ + "static/media/NG.dda0e5c8.svg";